// extracted by mini-css-extract-plugin
export default {"references":"ReferencesList_references__UZbOd","active":"ReferencesList_active__hzw8Y","references__tags":"ReferencesList_references__tags__PLV+J"};